import React from 'react';
import ImagePreview from '../chat/ImagePreview';

const ImagePreviews = ({ attachments, removeAttachment }) => {
	const previews = attachments.map((attachment) => (
		<ImagePreview
			key={attachment.path}
			attachment={attachment}
			removeAttachment={removeAttachment}
		/>
	));

	return <div className="flex flex-wrap items-end gap-2 pb-2">{previews}</div>;
};

export default ImagePreviews;
